import { Inject, Injectable } from '@angular/core';
import { SGKZ011AService, Sgkz011aRequest, Sgkz011aResponseUserOrganizationDto } from 'sg-api';
import { catchError, map, timeout } from 'rxjs/operators';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { ApiCommonService } from './api-common.service';
import { SharedLibConfig } from '../config/shared-lib-config';
import { SHARED_LIB_CONFIG } from '../config/shared-lib-config.token';
import { LoginUserIdService } from './login-user-id.service';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkz011aService {

  /** 二重呼び出し防止フラグ */
  // ユーザ情報取得の呼び出しは一度のみとする。
  public isCalledFlag = false;
  /** ユーザ名 */
  private _userKanjiname$ = new BehaviorSubject<string>('');
  /** ユーザID */
  private _userId$ = new BehaviorSubject<string>('');
  /** ユーザ組織情報 */
  private _userOrganizationInfo$ = new BehaviorSubject<Sgkz011aResponseUserOrganizationDto>({
    sosikiId: '',
    sosikiName: '',
    comgrpcd: '',
    comCode: '',
    topSosikiId: '',
    areaCd: '',
    kyotenHyojiFlg: '',
    cmpnyName: '',
  });

  /**
   * コンストラクタ。
   * @memberof UsedSgkz011aService
   */
  constructor(private sgkz011AService: SGKZ011AService,
    private apiCommonService: ApiCommonService,
    private loginUserIdService: LoginUserIdService,
    @Inject(SHARED_LIB_CONFIG) private sharedLibConfig: SharedLibConfig) { }

  /**
   * ユーザ名を取得
   *
   * @return {*}  {string}
   * @memberof UsedSgkz011aService
   */
  get userKanjiname(): Observable<string> {
    return this._userKanjiname$.asObservable();
  }

  /**
   * ユーザIDを取得
   *
   * @return {*}  {string}
   * @memberof UsedSgkz011aService
   */
  get userId(): Observable<string> {
    return this._userId$.asObservable();
  }

  /**
   * ユーザ組織情報を取得
   *
   * @return {*}  {Sgkz011aResponseUserOrganizationDto}
   * @memberof UsedSgkz011aService
   */
  get userOrganizationInfo(): Observable<Sgkz011aResponseUserOrganizationDto> {
    return this._userOrganizationInfo$.asObservable();
  }

  /**
   * ユーザIDを共有変数へ更新する。
   *
   * @memberof UsedSgkz011aService
   */
  public async updateUserInfo(): Promise<void> {

    // 二重呼び出し防止
    this.isCalledFlag = true;

    // ユーザID更新
    let userId = '';
    this.loginUserIdService.loginUserId.subscribe(loginUserId => {
      userId = loginUserId;
    });

    // リクエスト情報生成
    let request: Sgkz011aRequest = {
      requestCommon: {},
      userId: userId
    };

    // ユーザ情報を取得
    await this.sgkz011AService.kz10RSGKZ011APost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            // 受け取った情報を格納
            this._userKanjiname$.next(response.body.usrKanjiname);
            this._userId$.next(response.body.usrId);
            this._userOrganizationInfo$.next(response.body.sosikiInfo);
          }),

        timeout(Number(this.sharedLibConfig.httpTimeout)),
        catchError((err) => {
          return throwError(err).toPromise();
        })
      )
      .toPromise();
  }
}
